import UsersThree from 'assets/icons/UsersThree.svg'
import { DetailedHTMLProps, HTMLAttributes } from 'react'
import styled, { css } from 'styled-components'

interface IProps extends Omit<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, 'ref' | 'title'> {
  minHeight?: string
  title?: string
  message?: string
}
export const NoDataBox = ({ minHeight, title, message }: IProps) => {
  return (
    <Div minHeight={minHeight}>
      <UsersThree />
      <h1>{title || 'No Results'}</h1>
      <p>{message || 'It looks like there are no results that match your current search criteria.'}</p>
    </Div>
  )
}

const Div = styled.div<{ minHeight?: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  width: 100%;
  h1 {
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
  }
  p {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    width: 377px;
    text-align: Center;
  }

  ${({ minHeight }) =>
    minHeight &&
    css`
      min-height: ${minHeight};
    `};
`
